(() => {
  "use strict";

  document.addEventListener("DOMContentLoaded", () => {
    const accordionDetails = ".js-details";
    const accordionSummary = ".js-details-summary";
    const accordionContent = ".js-details-content";
    const radioSelector = ".js-details-radio";
    const closeButtonSelector = ".js-details-close"; // ← 追加
    const speed = 0.5;

    // -----------------------------------
    // アコーディオン処理
    // -----------------------------------
    document.querySelectorAll(accordionSummary).forEach((summary) => {
      const details = summary.closest(accordionDetails);
      const content = details.querySelector(accordionContent);

      // 初期状態で閉じる
      gsap.set(content, { height: 0, overflow: "hidden", display: "none" });

      summary.addEventListener("click", (event) => {
        event.preventDefault();
        summary.classList.toggle("-active");

        const isOpen = details.hasAttribute("open");

        if (isOpen) {
          // 閉じる処理
          gsap.killTweensOf(content);
          const currentHeight = content.scrollHeight;

          gsap.fromTo(
            content,
            { height: currentHeight, overflow: "hidden" },
            {
              height: 0,
              duration: speed,
              ease: "power2.in",
              onComplete: () => {
                details.removeAttribute("open");
                content.style.display = "none";
                content.style.height = "";
                content.style.overflow = "";
                gsap.set(content, { clearProps: "transform" });
              },
            }
          );
        } else {
          // 開く処理
          details.setAttribute("open", "true");
          content.style.display = "block";
          const fullHeight = content.scrollHeight;

          gsap.killTweensOf(content);
          gsap.fromTo(
            content,
            { height: 0, overflow: "hidden" },
            {
              height: fullHeight,
              duration: speed,
              ease: "power2.out",
              onComplete: () => {
                content.style.height = "auto";
                content.style.overflow = "";
                gsap.set(content, { clearProps: "transform" });
              },
            }
          );
        }
      });
    });

    // -----------------------------------
    // js-details-close クリックでアコーディオンを閉じる
    // -----------------------------------
    document.querySelectorAll(closeButtonSelector).forEach((btn) => {
      btn.addEventListener("click", (event) => {
        event.preventDefault();

        const details = btn.closest(accordionDetails);
        const summary = details.querySelector(accordionSummary);
        const content = details.querySelector(accordionContent);
        if (!content) return;

        if (details.hasAttribute("open")) {
          summary.classList.remove("-active");

          gsap.killTweensOf(content);
          const currentHeight = content.scrollHeight;

          gsap.fromTo(
            content,
            { height: currentHeight, overflow: "hidden" },
            {
              height: 0,
              duration: speed,
              ease: "power2.in",
              onComplete: () => {
                details.removeAttribute("open");
                content.style.display = "none";
                content.style.height = "";
                content.style.overflow = "";
                gsap.set(content, { clearProps: "transform" });
              },
            }
          );
        }
      });
    });

    // -----------------------------------
    // ラジオボタンの反映処理
    // -----------------------------------
    function updateSimulationSummary(radio) {
      const label = radio.closest(".js-details-label");
      const style = label?.getAttribute("style");
      const value = radio.value;

      const details = radio.closest(accordionDetails);
      const checked = details.querySelector(".js-details-summary-checked");
      const sub = details.querySelector(".js-details-summary-title-sub");

      if (checked && style) checked.setAttribute("style", style);
      if (sub) sub.textContent = "│" + value;
    }

    document.querySelectorAll(radioSelector).forEach((radio) => {
      radio.addEventListener("change", () => updateSimulationSummary(radio));

      // 初期状態で選択されているものを反映
      if (radio.checked) {
        updateSimulationSummary(radio);
      }

      // スクロール抑制
      radio.addEventListener("focus", (e) => {
        window.scrollTo(window.scrollX, window.scrollY);
      });
    });
  });
})();
